import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { Link } from 'react-router';
import { asDate } from '../../utils/Date';
import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';
// components
import IconButton from 'material-ui/IconButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
// icons
import SortAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';

// business logic
const sortMethods = {
    default: (a, b) => (a.id - b.id),
    fullName: (a, b) => ( a.firstName.localeCompare(b.firstName) || a.lastName.localeCompare(b.lastName)),
    email: (a, b) => (a.email.localeCompare(b.email)),
};

const ReportUsers = React.createClass({

    getInitialState: function () {
        let data = this.props.data.map(this.updateData);
        return {
            data: data,
            sortName: 'default',
            sort: sortMethods.default,
            filters: {
                name:       '',
                email:      '',
                manager:    '',
                department: '',
                userGroup:  '',
                lastLogin: ''
            }
        };
    },

    style: {
        textFilter: {
            width: '100%'
        }
    },

    componentWillReceiveProps: function(nextProps) {
        let data = nextProps.data.map(this.updateData);
        let state = assign(this.state, {data: data});
        this.setState(state);
    },

    render: function() {
        const tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        const tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        const tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };
        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }
        let textFilterProps = {
            hintText: 'Filter',
            onChange: this.setTextFilter,
            style:    this.style.textFilter
        };
        let data = this.state.data.filter(this.filterData).sort(this.state.sort);

        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>
                            Name
                            <IconButton onTouchTap={this._setSort('fullName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Email
                            <IconButton onTouchTap={this._setSort('email')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Manager</TableHeaderColumn>
                        <TableHeaderColumn>Department</TableHeaderColumn>
                        <TableHeaderColumn>User Group</TableHeaderColumn>
                        <TableHeaderColumn>Last login</TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                        <TableHeaderColumn>
                            <TextField name="name" value={this.state.filters.name} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="email" value={this.state.filters.email} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="manager" value={this.state.filters.manager} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="department" value={this.state.filters.department} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="userGroup" value={this.state.filters.userGroup} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn/>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map((row, index) => (
                        <TableRow key={index} selected={row.selected} style={{color: !row.archived ? statusColours.default : statusColours.waiting}}>
                            <TableRowColumn><Link to={row.link}>
                                {!row.archived
                                    ? row.fullName
                                    : <span style={{color: statusColours.waiting}} title="Archived user">{row.fullName}</span>
                                }
                            </Link></TableRowColumn>
                            <TableRowColumn>{row.email}</TableRowColumn>
                            <TableRowColumn>{row.manager}</TableRowColumn>
                            <TableRowColumn>{row.department}</TableRowColumn>
                            <TableRowColumn>{row.userGroup}</TableRowColumn>
                            <TableRowColumn>{!!row.lastLogin && asDate(row.lastLogin).toLocaleString('en-GB', DateStyles.shortDateTime)}</TableRowColumn>
                        </TableRow>
                    ))}
                </TableBody>

            </Table>
        );
    },

    _setSort: function(sort) {
        let _sort = sort;
        let self = this;
        return function() {
            if (sortMethods.hasOwnProperty(_sort) && self.state.sortName !== _sort) {
                self.setState({sortName: _sort, sort: sortMethods[_sort]});
            }
        };
    },

    setTextFilter: function(event) {
        this._setFilter(event.target.name, event.target.value.toLocaleLowerCase());
    },
    
    _setFilter: function(filter, value) {
        if (this.state.filters.hasOwnProperty(filter)) {
            let filters = this.state.filters;
            filters[filter] = value ;
            this.setState({filters: filters});
        }
    },

    updateData: function(row) {
        row.fullName = row.firstName + ' ' + row.lastName;
        row.manager = this.getList(row.managers);
        row.department = this.getList(row.departments);
        row.userGroup = this.getList(row.userGroups);
        row.link = '/dashboard/user/' + row.id;

        return row;
    },

    getList: function(line, separator) {
        let list = '';
        let spanProps = {
            style: {
                marginRight: '1em'
            },
            className: 'inline-list'
        };
        if (!!line) {
            list = line.split(separator || '|')
                .map(function(e, i) { return <span key={i} {...spanProps} >{e}</span>; });
        }
        return list;
    },

    filterData: function(row) {
        let valid = (row !== undefined);
        if (valid && !!this.state.filters.name) {
            valid = (-1 < row.firstName.toLocaleLowerCase().search(this.state.filters.name)) || (-1 < row.lastName.toLocaleLowerCase().search(this.state.filters.name));
        }

        if (valid && !!this.state.filters.email) {
            valid = (-1 < row.email.toLocaleLowerCase().search(this.state.filters.email));
        }

        if (valid && !!this.state.filters.userGroup) {
            valid = (!!row.userGroups && -1 < row.userGroups.toLocaleLowerCase().search(this.state.filters.userGroup));
        }

        if (valid && !!this.state.filters.department) {
            valid = (!!row.departments && -1 < row.departments.toLocaleLowerCase().search(this.state.filters.department));
        }
        
        if (valid && !!this.state.filters.manager) {
            valid = (!!row.managers && -1 < row.managers.toLocaleLowerCase().search(this.state.filters.manager));
        }

        return valid;
    },
});

ReportUsers.propTypes = {
    display: PropTypes.object,
    onRowSelect: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
};

export default ReportUsers;




